import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthTokenRetrieve, LoginButton, LogoutButton } from "../Utility/AuthTokenRetrieve";
import { apiFetch } from "../Utility/api";
import "../Food/RecipeList.css";
import "./BabyTracker.css";
import {
  defaultBabyEventForm,
  eventCategoryLabels,
  fetchBabySummary,
} from "./BabyTrackerShared";

const quickActions = [
  { label: "Wet Diaper", category: "diaper", type: "Wet" },
  { label: "Dirty Diaper", category: "diaper", type: "Dirty" },
  { label: "Mixed Diaper", category: "diaper", type: "Mixed" },
  { label: "Breast Feed", category: "feeding", type: "Breast" },
  { label: "Formula Bottle", category: "feeding", type: "Bottle Formula" },
  { label: "Milk Bottle", category: "feeding", type: "Bottle Milk" },
  { label: "Sleep", category: "sleep", type: "Sleep" },
  { label: "Wake Up", category: "sleep", type: "Wake Up" },
];

const BabyTrackerHome = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const [summary, setSummary] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const { shouldShow: shouldShowGoogle } = AuthTokenRetrieve();

  useEffect(() => {
    setShouldShow(shouldShowGoogle);
  }, [shouldShowGoogle]);

  const refreshSummary = () => {
    setLoading(true);
    fetchBabySummary()
      .then((data) => {
        setSummary(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!shouldShow) {
      setLoading(false);
      return;
    }
    refreshSummary();
  }, [shouldShow]);

  const quickAddEvent = (action) => {
    setStatusMessage("");
    const eventForm = defaultBabyEventForm(action.category, action.type);
    apiFetch("/baby-tracker/events", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(eventForm),
    })
      .then((response) => response.json())
      .then(() => {
        setStatusMessage(`${action.label} logged.`);
        refreshSummary();
      })
      .catch(() => {
        setStatusMessage("Unable to log event.");
      });
  };

  if (!shouldShow) {
    return (
      <div className="searchBarDiv formViewWrapper BabyTrackerLogin">
        <h2>Baby tracker</h2>
        <p>Sign in to view and manage shared baby tracking data.</p>
        <LoginButton setShouldShow={setShouldShow}></LoginButton>
      </div>
    );
  }

  const todayCounts = summary?.todayCounts || {};
  const lastEvents = summary?.lastEvents || {};

  return (
    <div className="BabyTrackerPage">
      <div className="searchBarDiv formViewWrapper BabyTrackerIntro">
        <div>
          <h2 className="BabyTrackerTitle">Baby tracker</h2>
          <p className="BabyTrackerSubtitle">
            Shared tracking for diapers, feeding, and sleep.
          </p>
        </div>
        <LogoutButton setShouldShow={setShouldShow}></LogoutButton>
      </div>

      <div className="shoppingListDiv BabyTrackerPanel BabyTrackerSinglePanel">
        <h3>Quick add</h3>
        <div className="BabyTrackerQuickGrid">
          {quickActions.map((action) => (
            <button
              key={`${action.category}-${action.type}`}
              className="summaryButton BabyTrackerQuickButton"
              onClick={() => quickAddEvent(action)}
            >
              {action.label}
            </button>
          ))}
        </div>
        {statusMessage ? <p className="BabyTrackerStatus">{statusMessage}</p> : null}
      </div>

      {loading ? <div className="shoppingListDiv BabyTrackerPanel">Loading baby data...</div> : null}

      <div className="BabyTrackerGrid">
        <div className="shoppingListDiv BabyTrackerPanel">
          <h3>Today</h3>
          <div className="BabyTrackerStatGrid">
            <div className="BabyTrackerStat">
              <strong>{todayCounts.diaper || 0}</strong>
              <span>Diapers</span>
            </div>
            <div className="BabyTrackerStat">
              <strong>{todayCounts.feeding || 0}</strong>
              <span>Feedings</span>
            </div>
            <div className="BabyTrackerStat">
              <strong>{todayCounts.sleep || 0}</strong>
              <span>Sleep Events</span>
            </div>
            <div className="BabyTrackerStat">
              <strong>{summary?.todayFeedingOunces || 0}</strong>
              <span>Ounces</span>
            </div>
          </div>
        </div>

        <div className="shoppingListDiv BabyTrackerPanel">
          <h3>Last events</h3>
          {["diaper", "feeding", "sleep"].map((category) => (
            <div className="BabyTrackerHistoryRow" key={category}>
              <div>
                <strong>{eventCategoryLabels[category]}</strong>
                <div>{lastEvents[category]?.eventType || "None yet"}</div>
              </div>
              <span>{lastEvents[category]?.occurredAt || ""}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="BabyTrackerGrid">
        <div className="shoppingListDiv BabyTrackerPanel BabyTrackerActionPanel">
          <h3>Detailed entry</h3>
          <p>Add amounts, feeding side, and notes when quick add is not enough.</p>
          <div className="BabyTrackerActionRow">
            <Link className="summaryButton BabyTrackerLinkButton" to="/baby-tracker/events">
              Open Log
            </Link>
          </div>
        </div>

        <div className="shoppingListDiv BabyTrackerPanel">
          <h3>Recent timeline</h3>
          {summary?.recentEvents?.length ? (
            summary.recentEvents.map((entry) => (
              <div className="BabyTrackerHistoryRow" key={entry.id}>
                <div>
                  <strong>{entry.eventType}</strong>
                  <div>{eventCategoryLabels[entry.eventCategory]}</div>
                </div>
                <span>{entry.occurredAt}</span>
              </div>
            ))
          ) : (
            <p>No baby events logged yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BabyTrackerHome;
